import { USERDATA_API_PATH } from "@/providers/SRP/constants";
import { useSrpApiContext } from "@/providers/SRP/provider";
import type { POSTArgs } from "@/providers/SRP/types";
import { useMutation } from "@tanstack/react-query";

/**
 * Custom hook for posting user data
 *
 * @param {string} csrftoken - CSRF token for request validation
 * @returns {UseMutationResult} Mutation object for posting user data
 * @throws {Error} When used outside of SrpApiContext
 */
export default function usePostUserData(csrftoken: string) {
	const context = useSrpApiContext();
	if (!context) {
		throw new Error("SrpApiContext not found");
	}
	const { postFn } = context;
	return useMutation({
		mutationFn: async (args: Omit<POSTArgs, "pathname">) =>
			postFn({
				pathname: USERDATA_API_PATH,
				csrftoken,
				...args,
			}),
	});
}
